import appconfig from '@/utils/appConfig';
import clsx from 'clsx';

interface ErrorDisplayProps {
    meta: { touched?: boolean; error?: string | undefined };
}

const ErrorDisplay = ({ meta }: ErrorDisplayProps) => {
    const isInErrorState = meta.touched && meta.error;

    const errorSpanClasses = clsx(
        'error-message',
        'w-full',
        'text-xs',
        `${appconfig.colors.dangerText}`,
        'h-4'
    );

    return (
        <span className={errorSpanClasses}>
            {/* Keeping the error container always visible to stop page shift */}
            {isInErrorState && meta.error && meta.error}
        </span>
    );
};

export default ErrorDisplay;
